<template>
    <div class="flex relative justify-center pt-8">
        <div class="w-20 absolute left-0 flex items-center">
            <div class="whitespace-nowrap text-sm">Отображать по:</div>
            <dropdown v-model="itemsPerPage" theme="white" class="min-w-16 ds-pager-page-size" :options>{{ itemsPerPage.name }}</dropdown>
        </div>
        <vue-awesome-paginate
            v-if="items > effectiveItemsPerPage"
            :total-items="items"
            :items-per-page="effectiveItemsPerPage"
            :max-pages-shown="5"
            v-model="currentPage"
            @click="onClickHandler"
            :hide-prev-next="true"
        />
    </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { VueAwesomePaginate } from 'vue-awesome-paginate'
const { items } = defineProps({
    items: {
        type: Number,
        required: true,
        default: 0
    }
})

const emit = defineEmits(['page', 'perpage'])

const options = [
    { id: 15, name: '15' },
    { id: 30, name: '30' },
    { id: 'all', name: 'Все' }
]
const itemsPerPage = ref(options[0])
const currentPage = defineModel<number>('page', { default: 1 })

const effectiveItemsPerPage = computed<number>(() => {
    const id = itemsPerPage.value.id
    return id === 'all' ? items : (id as number)
})

const onClickHandler = (page: number) => {
    emit('page', {page, itemsPerPage: itemsPerPage.value})
}

// watch(() => items, () => {
//     onClickHandler(1)
// })
watch(itemsPerPage, () => {
    currentPage.value = 1
    onClickHandler(1)
})

</script>

<style>
  .pagination-container {
    display: flex;
    column-gap: 5px;
  }

  .paginate-buttons {
    height: 24px;
    width: 24px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }

  .active-page {
    background: #211A4D;
    color: white;
  }

</style>